// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__2AeTF","sendOtp":"AuthorizeToLogin_sendOtp__Cee1z"};